import React from 'react';
import withIcon from '../utilities/withIcon';

const IconToggle = () => {
  return (
    <g>
      <path d="m11.1719 3.3008h-6.3438a4.6992 4.6992 0 0 0 0 9.3984h6.3438a4.6992 4.6992 0 0 0 0-9.3984zm-9.543 4.6992a3.203 3.203 0 0 1 3.1992-3.1992h2.9219a4.6454 4.6454 0 0 0 0 6.3984h-2.9219a3.203 3.203 0 0 1 -3.1992-3.1992z" />
    </g>
  );
};

export default withIcon(IconToggle);
